import useSWR, { type SWRConfiguration } from "swr";
import type { ReleasesGeoJsonResponse } from "./type";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import { config } from "@/config";
import { isEmpty } from "@utils/formatters";
import type { ReleasesFilters } from "../list/type";

async function getReleasesGeoJson(
  query?: ReleasesFilters,
): Promise<ReleasesGeoJsonResponse> {
  const params = new URLSearchParams();

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (isEmpty(value)) return;

      params.append(key, String(value));
    });
  }

  let url = apiPaths.releases.getGeoJson;

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<ReleasesGeoJsonResponse>(url);

  return response.data;
}

export function useGetReleasesGeoJson(
  query?: ReleasesFilters,
  options?: SWRConfiguration & { enabled?: boolean },
) {
  const enabled = options?.enabled ?? true;

  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    revalidateOnFocus: false,
    ...options,
  };

  return useSWR(
    enabled ? [`fetch-releases-geojson`, JSON.stringify(query ?? {})] : null,
    () => getReleasesGeoJson(query ?? {}),
    mergedOptions,
  );
}
